import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import copy from './copy';
import './ToS.css';

const ToS = () => (
  <div className="pageContent">
    <h1>{copy.get('title')}</h1>
    {/*
      Safe to not escape HTML, as input not user-generated
      Since Markdown doesn't support underlined text, <u> tag is used in source file
    */}
    <ReactMarkdown source={copy.get('content')} escapeHtml={false} />
  </div>
);

export default ToS;
